import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import MButton from "@/components/atom/MButton";
import {getUserPhotos} from "@/api/photo";
import _ from "lodash";
import HomePagePanel from "@/components/homePage/HomePagePanel";
import {getUketoriTargetUser} from "@/api/exchange";
import globalStyle from "@/styles/Global.scss";

const UketoriCardHomePage = () => {
  const history = useHistory()
  const {id} = useParams()
  const [photos, setPhotos] = useState([])

  useEffect(() => {
    (async () => {
      const cardExchangeUser = await getUketoriTargetUser({id})
      const photos = await getUserPhotos({userId: cardExchangeUser.id})
      setPhotos(photos)
    })()
  }, [id])

  const toBack = () => {
    history.push(`/uketori/${id}`)
  }

  return (
    <>
      <Layout category={'UK'} title={'ホームページ'}>
        <div>
          <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
        </div>
        <div>
          {
            _.map(photos, (p) => {
              return (
                <React.Fragment key={p.id}>
                  <HomePagePanel photo={p}></HomePagePanel>
                  <hr className={globalStyle.separator} />
                </React.Fragment>
              )
            })
          }
        </div>
        <div>
          <MButton image={'back.png'} value={'戻る'} onClick={toBack}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default UketoriCardHomePage
